import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-content-preloader',
  templateUrl: './content-preloader.component.html',
  styleUrls: ['./content-preloader.component.scss']
})
export class ContentPreloaderComponent {}

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule],
  declarations: [ContentPreloaderComponent],
  exports: [ContentPreloaderComponent]
})
export class ContentPreloaderModule {}
